import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LAB,
  DELETE_LAB,
  GET_LABS,
  UPDATE_LAB,
  UPDATE_LAB_STATUS
} from "./actionTypes";

import {
  addLabFail,
  addLabSuccess,
  deleteLabFail,
  deleteLabSuccess,
  getLabsFail,
  getLabsSuccess,
  setState,
  updateLabFail,
  updateLabSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { labs, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLabs({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labs, params.toString());
    yield put(setState(false));
    yield put(getLabsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabsFail(error));
  }
}

function* updateLab({ payload: labObj }) {
  try {
    const { id, recordStatus, ...rest } = labObj;
    yield call(patchApiCall, `${labs}/${id}`, rest);
    const response = yield call(getTable, `${labs}/${labObj.id}`);
    yield put(updateLabSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateLabFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateLabStatus({ payload: labObj }) {
  try {
    const { id } = labObj;
    yield call(patchApiCall, `${labs}/${updateStatus}/${id}`, { recordStatus: labObj.recordStatus });
    const response = yield call(getTable, `${labs}/${labObj.id}`);
    yield put(updateLabSuccess(response));
  } catch (error) {
    yield put(updateLabFail(error));
  }
}

function* deleteLab({ payload: labObj }) {
  try {
    yield call(deleteApiCall, `${labs}/${labObj.id}`);
    yield put(deleteLabSuccess(labObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteLabFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingLab({ payload: lab }) {
  try {
    const response = yield call(postApiCall, labs, lab);
    const responseDetails = yield call(getTable, `${labs}/${response.id}`);
    yield put(addLabSuccess(responseDetails));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    toast.error('Error al agregar el registro');
    yield put(addLabFail(error));
  }
}

function* labsSaga() {
  yield takeEvery(GET_LABS, fetchLabs);
  yield takeEvery(ADD_NEW_LAB, postingLab);
  yield takeEvery(UPDATE_LAB, updateLab);
  yield takeEvery(UPDATE_LAB_STATUS, updateLabStatus);
  yield takeEvery(DELETE_LAB, deleteLab);
}

export default labsSaga;